import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { history } from "../../history";
import { setRedirectTo } from "../../redux/action";
import AlertDialog from "../AlertDialog/AlertDialog";

const AuthContext = createContext({
    isChangingPassword: false,
    setIsChangingPassword: () => {},
});

export function AuthProvider({ children }) {
    const dispatch = useDispatch();
    const [isChangingPassword, setIsChangingPassword] = useState(() => {
        // 从 sessionStorage 恢复状态（应对页面刷新）
        if (sessionStorage.getItem("isChangingPassword") === "true") {
            dispatch(setRedirectTo("/changePassword"));
        }
        return sessionStorage.getItem("isChangingPassword") === "true";
    });

    const [changePasswordMsg, setChangePasswordMsg] = useState(false);

    const { t } = useTranslation();

    const location = useLocation();

    // 监听路由变化（包括地址栏直接修改）
    useEffect(() => {
        const unlisten = history.listen(({ location, action }) => {
            if (
                isChangingPassword &&
                location.pathname !== "/eformss/changePassword" &&
                location.pathname !== "/eformss/Login"
            ) {
                setChangePasswordMsg(true);
                history.replace("changePassword"); // 强制回到当前页
            }
        });
        if (
            isChangingPassword &&
            location.pathname !== "/changePassword" &&
            location.pathname !== "/Login"
        ) {
            setChangePasswordMsg(true);
            history.replace("changePassword"); // 强制回到当前页
        }

        if (isChangingPassword && location.pathname === "/Login") {
            setIsChangingPassword(false);
        }
        return () => unlisten();
    }, [isChangingPassword]);

    // 浏览器刷新/关闭拦截
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isChangingPassword) {
                e.preventDefault();
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () =>
            window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [isChangingPassword]);

    // 同步状态到 sessionStorage
    useEffect(() => {
        sessionStorage.setItem(
            "isChangingPassword",
            isChangingPassword.toString()
        );
    }, [isChangingPassword]);

    return (
        <AuthContext.Provider
            value={{ isChangingPassword, setIsChangingPassword }}
        >
            {children}
            <AlertDialog
                formOpen={changePasswordMsg}
                content={t("errorMsg.login.passwordExpired")}
                confirmButton={{
                    action: () => {
                        setChangePasswordMsg(false);
                    },
                    label: t("common.reload.popup.confirm"),
                }}
            />
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
